export default __webpack_public_path__ + "static/media/green2.3a52b89b.png";